import { useMemo } from 'react';
/**
 * Returns function that sets ref and invokes provided ref callback function.
 */

function createSetRefWithEffect(forwardedRef, callback) {
  return function (node) {
    if (callback) {
      callback(node);
    }

    if (typeof forwardedRef === 'function') {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  };
}
/**
 * Returns memoized function that sets ref with side effect.
 */


function useRefWithEffectMemoized(forwardedRef, callback) {
  return useMemo(function () {
    return createSetRefWithEffect(forwardedRef, callback);
  }, [forwardedRef, callback]);
}

export { useRefWithEffectMemoized as useRefWithEffect };